import React, {useEffect, useRef, useState} from 'react';
import './wheel.css';
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import associateServices from "../../../services";
import Loading from "../../../components/loading";
import {toast} from "react-toastify";
import InformationToast from "../../../components/toast/InformationToast";
import {useNavigate, useSearchParams} from "react-router-dom";
import {Modal} from "react-bootstrap";
import Countback from "../../../components/countback";
import Leaderboard from "../../tournaments/leaderboard";
import WheelLatest from "./wheel-latest";
import confetti from "canvas-confetti";


const WheelHomepage = props => {
    const {authenticated} = useSelector(state => state.authenticationReducer)
    const {agent} = useSelector(state => state.globalReducer)
    const {activeLanguage, configuration} = useSelector(state => state.globalReducer)
    const [loading, setLoading] = useState(true);
    const [spinning, setSpinning] = useState(false);
    const [result, setResult] = useState(null);
    const [imageLoaded, setImageLoaded] = useState(true);

    const [tickets, setTickets] = useState({})
    const [types, setTypes] = useState([])
    const [activeType, setActiveType] = useState('')
    const wheelRef = useRef();
    const [searchParams, setSearchParams] = useSearchParams()

    const navigate = useNavigate()
    useEffect(() => {
        if (!configuration?.wheel_able)
            navigate('/')
    }, [configuration?.wheel_able])
    const handleRegister = () => {
        searchParams.set('modal', 'register')
        setSearchParams(searchParams)
    }

    const spin = () => {

        if (!authenticated)
            return handleRegister()

        if (spinning) return;

        wheelRef.current.style.transition = 'none';
        wheelRef.current.style.transform = 'rotate(0deg)';

        setSpinning(true);
        setResult(null);

        associateServices.spinWheel({
            type_id: activeType?.type_id
        }).then(res => {

            getCustomerTickets()

            if (res?.status !== 200) {
                toast(<InformationToast
                    icon={'ti-error-404'}
                    title={t('general.information')}
                    message={t(`api-notifications.${res?.errors}`)}
                />)

                setResult(null)
                return setSpinning(false)
            }
            const degreePerSegment = 360 / 8;
            // const index = weightedRandom(segments);
            const index = res?.data?.result_id;

            const baseRotation = 3600;
            const segmentAngle = index * degreePerSegment;
            // const offset = (Math.random() * (degreePerSegment - degreePerSegment / 8)) - (degreePerSegment / 8);
            const offset = 0

            const finalRotation = baseRotation - segmentAngle + offset;
            // const duration = Math.random() * 2.6 + 4.2; // 4.2 - 6.8s
            const duration = 15; // 4.2 - 6.8s

            const audio = document.getElementById('wheel-sound');
            if (audio) {
                audio.currentTime = 0;
                audio.play().catch((e) => {
                    console.warn('Autoplay blocked:', e);
                });
            }

            wheelRef.current.style.transition = `transform ${duration}s cubic-bezier(0.25, 1, 0.5, 1)`;
            wheelRef.current.style.transform = `rotate(${finalRotation}deg)`;

            setTimeout(() => {
                if (audio) {
                    const fadeInterval = setInterval(() => {
                        clearInterval(fadeInterval);
                        audio.pause();
                        audio.currentTime = 0;
                        audio.volume = 1;
                    }, 100);
                }

                setSpinning(false);
                navigate(`?modal=wheel-prize&prize=${res?.data?.prize_id}`)
                // setResult(segments[index].label);
            }, duration * 1000);
        })


    };

    const {t} = useTranslation()


    useEffect(() => {
        if (activeLanguage?.key)
            associateServices.getWheelTypes({
                lang: activeLanguage?.key
            }).then(res => {

                setTypes(res?.data)
                setActiveType(res?.data[0])

                setLoading(false)
            })
    }, [activeLanguage])


    useEffect(() => {

        if (authenticated && types?.length >= 1)
            getCustomerTickets()
    }, [types, authenticated])


    const getCustomerTickets = () => {
        associateServices.getWheelTickets({
            lang: activeLanguage?.key
        }).then(res => {
            if (res?.status === 200) {
                setTickets(res?.data || {})
            }
        })
    }
    useEffect(() => {
        if (activeType?.wheel) {
            handleClaim()
            setImageLoaded(true); // reset before load
            const img = new Image();
            img.src = activeType.wheel;
            img.onload = () => setImageLoaded(true);
        }
    }, [activeType]);

    const [showResultModal, setShowResultModal] = useState(false);


    useEffect(() => {
        if (showResultModal) {
            searchParams.append('modal', 'wheel-prize')
            setSearchParams(searchParams)
        }
    }, [showResultModal])
    const canvasRef = useRef(null);

    const handleClaim = () => {


        setTimeout(() => {
            const myConfetti = confetti.create(canvasRef.current, {
                resize: true,
                useWorker: true,
            });

            myConfetti({
                particleCount: 1200,
                spread: 560,
                origin: { y: 0.2 },
            });

        }, 500);
    };



    return (
        <div className="section">
            <canvas ref={canvasRef} className="gift-confetti-canvas" />

            <div className="container">
                <div className="row">

                    <div className={agent?.isMobile? '':'"col-12 d-flex justify-content-between align-items-center"'}>
                        <h1 className="section__title section__title--head">{t('wheel.title')}</h1>

                        <div>
                            <ul className="tags">
                                {
                                    types?.map(type => (
                                        <li className="nav-item" role="presentation" key={type}>
                                            <button
                                                onClick={e => !spinning && setActiveType(type)}
                                                className={`wheel tabs-nav__btn ${activeType?.type_id === type?.type_id ? 'active' : ''}`}
                                                type="button">
                                                {type?.title}
                                                {
                                                    tickets[type?.type_id] ? <div className="wheel-badge">
                                                        {tickets[type?.type_id]}
                                                    </div> : null
                                                }
                                            </button>


                                        </li>
                                    ))
                                }

                            </ul>
                        </div>
                    </div>

                    <div className="col-12 col-xxl-7">
                        <div className="content">
                            <div className="content__main content__main--big p-0">
                                {
                                    (loading || !imageLoaded) ? <Loading/> :
                                        <div id="general-everything">
                                            <audio id="wheel-sound"
                                                   src="https://cdn.ebetlab.com/ebetlab/wheel-sound.mp3"
                                                   preload="auto"/>

                                            <div id="general-wheel">

                                                <div className="wheel-area">
                                                    <div id="wheel-pre"></div>
                                                    <div id="wheel-container">
                                                        <div id="wheel"
                                                             style={{
                                                                 backgroundSize: 'cover',
                                                                 background: `url("${activeType?.wheel}") no-repeat center`,
                                                             }}
                                                             ref={wheelRef}></div>
                                                        <button id="spin-button" onClick={spin}></button>
                                                    </div>
                                                    <div id="wheel-after"/>

                                                    <span>{result}</span>
                                                </div>

                                            </div>
                                        </div>
                                }
                            </div>
                        </div>

                        <div className="content__main content__main--big">
                            <div className="article">
                                <div dangerouslySetInnerHTML={{__html: activeType?.content}}/>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-xxl-5">
                        <div className="content" id="tournament-leaderboard">
                            <div className="content__main content__main--big">
                                <div className="table-responsive w-100">
                                    <WheelLatest activeType={activeType}/>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    )
};

export default WheelHomepage;
